export enum ProductLabelTypeEnum {
  Empty = 'empty',
  New = 'new',
  Top = 'top',
  Sale = 'sale',
}
